import Loader from "react-loader-spinner";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import DatePicker from 'react-datepicker2';
import "react-datepicker2/src/styles/style.css";
import BihamtaTable from "../../Components/BihamtaTable";
import { useEffect, useState, useRef, Fragment } from "react";
import { faCommentAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Card, Col, Form, FormGroup, Row } from "react-bootstrap";
import { CalendarXFill, CheckLg, DashCircle, EyeFill, EyeSlashFill, InfoCircleFill, JournalX, Link45deg, PhoneVibrateFill, Search, X } from "react-bootstrap-icons";
import { attachFile, downloadFile, setErrorDialog } from "../../store/api/CommonFunctions";
import { addCustomerTicket, getCustomerTicketList, getCustomerTicket, getCustomerTicketList_Local, closeCustomerTicket, deleteCustomerTicket } from "../store/api/CustomerApi";
import { useHistory } from "react-router-dom";
import { setDialog } from "../store/api/Modals";
import BihamtaMultiSelect from "../../Accounting/Components/BihamtaMultiSelect";

const Ticket = () => {

    const frmTicket = useRef();
    const inputFile = useRef();
    const inputDateTo = useRef();
    const history = useHistory();
    const dateFilters = useRef({});
    const filterData = useRef({ TicketStatusList: [] });
    const inputDateFrom = useRef();
    const dispatch = useDispatch();
    const [currTicket, setCurrTicket] = useState(null);
    const [showFilters, setShowFilters] = useState(true);
    const { register, errors, handleSubmit } = useForm();
    const ticketList = useSelector(state => state.customerDataReducer.customerTicketList?.Data ?? []);
    const selectStatusOptions = [
        { value: "Registered", text: "جدید" },
        { value: "UnderChecking", text: "دردست بررسی" },
        { value: "CheckedOut", text: "بررسی شده" },
        { value: "Closed", text: "بسته شده" }
    ]


    const tableColes = [
        { colTitle: "ردیف", colName: "RowNumber", showInMobile: true, styleCondition: (row) => row.IsNew ? { fontWeight: "bold" } : { fontWeight: "normal" } },
        { colTitle: " وضعیت تیکت", colName: "PTicketStatus", showInMobile: true, styleCondition: (row) => row.IsNew ? { fontWeight: "bold" } : { fontWeight: "normal" } },
        { colTitle: "تاریخ تیکت", colName: "PTicketDate", showInMobile: true, styleCondition: (row) => row.IsNew ? { fontWeight: "bold" } : { fontWeight: "normal" } },
        { colTitle: "موضوع تیکت", colName: "TicketSubject", showInMobile: true, styleCondition: (row) => row.IsNew ? { fontWeight: "bold" } : { fontWeight: "normal" } },
        { colTitle: "شرح تیکت", colName: "TicketDesc", showInMobile: false, colType: "string", maxTextLength: 120, styleCondition: (row) => row.IsNew ? { fontWeight: "bold" } : { fontWeight: "normal" } },
        { colTitle: "تاریخ آخرین پاسخ", colName: "PLastUpdate", showInMobile: false, styleCondition: (row) => row.IsNew ? { fontWeight: "bold" } : { fontWeight: "normal" } },
        { colTitle: "مشخصات مشتری", colName: "CustomerName", showInMobile: false, styleCondition: (row) => row.IsNew ? { fontWeight: "bold" } : { fontWeight: "normal" } },
        { colTitle: "شناسه پیگیری", colName: "ID", showInMobile: false, styleCondition: (row) => row.IsNew ? { fontWeight: "bold" } : { fontWeight: "normal" } }
    ]
    const tableRowButtons = [{
        title: "نمایش جزئیات", type: "show", className: "group-Btn-smalll btn-primary",
        onclick: (item) => showTicket(item)
    }, {
        title: "حذف تیکت", type: "delete", className: "group-Btn-smalll btn-danger",
        style: { marginRight: "5px" },
        onclick: (item) => dispatch(setDialog({
            status: 'show',
            arrayBtn: ['yes', 'no'],
            dialogTitle: 'حذف تیکت',
            dialogText: 'آیا از حذف مطمئن هستید؟',
            okOperation: deleteTicket(item)
        }))
    },
    {
        title: "فرم مرتبط",
        type: "related",
        className: "group-Btn-small btn-info",
        tooltip: "فرم مرتبط",
        showCondition: (item) => (item?.FormAttachmentType ?? "").length > 0,
        onclick: gotoAttachmentForm
    }
    ];
    function gotoAttachmentForm(item) {
        if (item.FormAttachmentType.toLowerCase() === "install" || item.FormAttachmentType.toLowerCase() === "repair") {
            window.open(`/Services/Service/${item.FormAttachmentID}/${item.FormAttachmentType}`);
        }
    }
    function addTicket(data) {
        const onSuccess = (res) => {
            const id = res.ResponseID ? res.ResponseID : res.ID;
            dispatch(attachFile(inputFile.current, id, "CustomerTicket", () => frmTicket.current.reset()));
            //For When Ticket Is New
            if (res.ID && res.TotalCount) {
                dispatch(getCustomerTicketList_Local({ ...res }));
                setCurrTicket({ ID: res.ID, ...data });
            }
            //
            else if (res.Data) {
                setCurrTicket({ ...res.Data });
            }
        }
        addCustomerTicket(data, onSuccess);
    }
    function cancelTicket() {
        setCurrTicket(null);
    }
    function showTicket(ticket) {
        const getTicket = (res) => {
            if (res === "PENDING") {
                setCurrTicket("PENDING");
            }
            else {
                setCurrTicket(res.Data);
            }
        }
        getCustomerTicket(ticket.ID, getTicket);
    }
    function closeTicket() {
        const onSuccess = (res) => {
            if (res.Error) {
                setErrorDialog(dispatch, res.Error, "بستن تیکت");
                return;
            }
            setCurrTicket(null);
            dispatch(getCustomerTicketList(filterData.current));
        }
        closeCustomerTicket(currTicket.ID, onSuccess)
    }
    function deleteTicket(ticket) {
        const onSuccess = (res) => {
            if (res.Error) {
                setErrorDialog(dispatch, res.Error, "حذف تیکت");
                return;
            }
            if (res === "Success") {
                const removed = ticketList.filter(t => t.ID !== ticket.ID);
                dispatch(getCustomerTicketList_Local({ Data: removed }));
            }
        }
        return () =>
            deleteCustomerTicket(ticket.ID, onSuccess)
    }
    function search(filters) {
        if (inputDateFrom.current.input.value !== "") {
            filters.TicketDateFrom = dateFilters.current.TicketDateFrom;
        }
        if (inputDateTo.current.input.value !== "") {
            filters.TicketDateTo = dateFilters.current.TicketDateTo;
        }
        if(!filters.Take)
        {
            filters.Take = 30;
        }
        filters.TicketStatusList = filterData.current.TicketStatusList;
        filterData.current = { ...filters, Skip: 0 }

        dispatch(getCustomerTicketList(filters));
    }
    function copyTooltip() {
        const span = document.getElementsByClassName("rightTooltip")[0];
        const elList = [...span.getElementsByTagName("label")];
        let txt = "";
        elList.forEach(el => {
            if (el.textContent.replace(/\s/g, "") !== "") {
                txt += " " + el.textContent.replace(/\s/g, "")
            }
        });

        navigator.clipboard.writeText(txt).then(() => {
            console.log(txt);
        });
    }
    function gotoCustomer() {
        history.push(`/CRM/AddEditCustomer/${currTicket.CustomerID}`);
    }
    function downloadNoticeAttachFile() {
        downloadFile(currTicket.FormAttachmentID, "Notice");
    }
    function showHideFilter(hide) {
        const divFilters = document.getElementById("divFilters");
        if (hide) {
            divFilters.classList.add("hiddenRow");
            setShowFilters(false);
        }
        else {
            divFilters.classList.remove("hiddenRow");
            setShowFilters(true);
        }
    }
    function onStatusChecked(item) {

        if (item.checked) {
            filterData.current.TicketStatusList = [...filterData.current.TicketStatusList, item.value];
        }
        else {
            const newStatusList = filterData.current.TicketStatusList.filter(s => s !== item.value);
            filterData.current.TicketStatusList = newStatusList;
        }
    }
    useEffect(() => {
        document.body.classList = "notMain";
        document.title = "بی همتا-مشتریان";
        filterData.current.Take = 30;
        filterData.current.Skip = 0;
        dispatch(getCustomerTicketList({ ByCustomer: false, Take:30 }));
    }, []);
    return (
        <div className="container-fluid mt-1">
            <br />
            <Card style={{ textAlign: "right" }}>
                <Card.Header className="headerStyle">
                    <FontAwesomeIcon icon={faCommentAlt} size="lg" />
                    &nbsp;
                    <h6 style={{ display: "inline-block", margin: "auto" }}>تیکت های مشتریان</h6>
                </Card.Header>
                <Card.Body className="bodyStyle">
                    {currTicket &&
                        <Row className="rowBorder" style={{ padding: "10px", margin: 0 }}>

                            {currTicket === "PENDING" && <Col style={{ textAlign: "center" }}> <Loader type="BallTriangle" width={25} height={25} color="#bb1370" /> </Col>}
                            {Number(currTicket.ID) > 0 &&

                                <div style={{ position: "relative" }}>
                                    {currTicket.TicketStatus === "Closed" && <label style={{ padding: "5px", color: "red", border: "2px solid red", borderRadius: "2px", transform: "rotate(-20deg)", boxShadow: "0 0 3px", textShadow: "0px 0px 2px red", position: "absolute", left: "-25px", top: "-20px" }}>بسته شده</label>}
                                    <Row style={{ margin: 0 }}>
                                        <Col md={2} style={{ background: "#148385", padding: "5px", color: "white", borderRadius: "2px", marginLeft: "3px" }}>
                                            <span className="tooltipBtn" data-tooltip={currTicket.CustomerPhone}>
                                                <InfoCircleFill size={17} color="orange" className="hoverIcon tooltipBtn" onClick={gotoCustomer} />&nbsp;مشتری: {currTicket.CustomerName}
                                            </span>
                                            {/* <span className="rightTooltip" onClick={copyTooltip}>
                                                <label><PhoneVibrateFill size={15} color="blue" />&nbsp; {currTicket.CustomerPhone}</label>
                                                <label style={{ display: "block" }}><CalendarXFill size={15} color="blue" />&nbsp; {currTicket.GuaranteeEndDate}</label>
                                            </span> */}
                                        </Col>
                                        <Col md={2} style={{ background: "#941262", padding: "5px", color: "white", borderRadius: "2px", marginLeft: "3px" }}>تاریخ ثبت: <span style={{ fontSize: "11px" }}>{currTicket.TicketHour}</span>-{currTicket.PTicketDate}</Col>
                                        <Col md={1} style={{ background: "#3560b1", padding: "5px", color: "white", borderRadius: "2px" }}>شناسه پیگیری: {currTicket.ID}</Col>
                                        {Number(currTicket.AttachmentID) > 0 && <Col md={1} style={{ padding: 0 }}><Link45deg size={25} color="#c32baa" className="hoverIcon" onClick={() => downloadFile(currTicket.AttachmentID, "CustomerTicket")} /> </Col>}

                                    </Row>
                                    <div className="mt-2 col-md-6">
                                        <label>موضوع: </label>
                                        <Form.Control value={currTicket.TicketSubject} disabled={true} style={{ fontSize: "13px", fontWeight: "bold" }} />
                                    </div>
                                    <div className="mt-2">
                                        <label>شــرح: </label>
                                        <Form.Control as="textarea" rows={2} value={currTicket.TicketDesc} disabled={true} style={{ fontSize: "13px" }} />
                                    </div>
                                    {currTicket.RelatedNoticeDesc && currTicket.RelatedNoticeDesc.length > 0 &&
                                        <div className="mt-1">
                                            <label style={{ color: "#4600ff" }}>شرح اطلاعیه: </label> &nbsp;{currTicket.NoticeHasAttachment && <Link45deg color="#c32baa" className="hoverIcon" size={22} onClick={downloadNoticeAttachFile} style={{ cursor: "pointer" }} />}
                                            <Form.Control as="textarea" rows={2} value={currTicket.TicketDesc} disabled={true} style={{ fontSize: "13px", backgroundColor: "#fce0fc6b" }} />
                                        </div>
                                    }
                                    {currTicket.TicketStatus !== "Closed" &&
                                        <div className="mt-2">
                                            <Button className="group-Btn-large" onClick={closeTicket}><JournalX size={16} />&nbsp; بستن تیکت</Button>
                                        </div>
                                    }
                                </div>

                            }
                            {
                                currTicket.Responses && Array.isArray(currTicket.Responses) && currTicket.Responses.length > 0 &&
                                <div className="rowBorder mt-4" style={{ borderColor: "#ff00003b", boxShadow: "0 0 1px" }}>
                                    <div className="rowTitle">پاسخ ها</div>
                                    <div style={{ maxHeight: "290px", overflow: "auto" }}>
                                        {currTicket.Responses.map((res, i) =>
                                            <Card style={{ margin: "12px", background: "transparent" }} key={i}>
                                                <Card.Body>
                                                    <div style={{ position: "absolute", padding: "5px", background: "#c470e5", top: "-5px", left: "-5px", transform: "rotate(-20deg)", fontSize: "11px", borderRadius: "2px", boxShadow: "0px 0px 2px" }}>
                                                        {res.PTicketDate}
                                                    </div>
                                                    <div style={{ position: "absolute", padding: "1px 5px 1px 5px", background: "#7077e5", top: "16px", left: "6px", transform: "rotate(-10deg)", fontSize: "11px", borderRadius: "2px", color: "white", boxShadow: "0px 0px 2px black" }}>
                                                        {res.TicketHour}
                                                    </div>
                                                    {res.AttachmentID &&
                                                        <div style={{ position: "absolute", padding: "1px 5px 1px 5px", top: "5px", left: "46px", color: "#ff2300", cursor: "pointer" }} className="hoverIcon">
                                                            <Link45deg size={24} onClick={() => downloadFile(res.AttachmentID, "CustomerTicket")} />
                                                        </div>
                                                    }
                                                    {i === 0 &&
                                                        <span className="form-control" style={{ backgroundColor: res.ResponderName ? "#ede9ef" : "#dadef6", border: "none", fontSize: "13px", minHeight: "50px" }} >{res.TicketDesc}</span>
                                                    }
                                                    {i > 0 &&
                                                        <Form.Control as="textarea" rows={window.innerWidth > 414 ? 2 : 3} value={res.TicketDesc} readOnly style={{ backgroundColor: res.ResponderName ? "#ede9ef" : "#dadef6", border: "none", fontSize: "13px" }} />}
                                                    <div style={{ position: "absolute", padding: "1px 5px 1px 5px", background: "#595a95", bottom: "22px", left: "22px", fontSize: "11px", borderRadius: "2px", color: "white", boxShadow: "0px 0px 2px black" }}>
                                                        {res.ResponderName ? res.ResponderName : res.CustomerName}
                                                    </div>
                                                </Card.Body>
                                            </Card>
                                        )
                                        }
                                    </div>
                                </div>
                            }
                            {Number(currTicket.ID) > 0 && currTicket.TicketStatus !== "Closed" &&
                                <form ref={frmTicket} onSubmit={handleSubmit(addTicket)} readOnly>
                                    <div style={{ border: "1px solid orange", height: "1px", marginTop: "10px" }}></div>
                                    <input type="hidden" name="ParentID" ref={register({ required: true })} value={currTicket.ID} />
                                    <FormGroup className="mt-1">
                                        <label>شــرح: </label>
                                        <Form.Control as="textarea" rows={2} name="TicketDesc" ref={register({ required: true })} />
                                        {errors?.TicketDesc && <small className="errors">شرح تیکت الزامی است</small>}
                                    </FormGroup>
                                    <Fragment>
                                        <Form.Group>
                                            <label>پیوست: </label>
                                            <input type="file" className="form-control" ref={inputFile} />
                                        </Form.Group>
                                        <div className="mt-2">
                                            <Button className="group-Btn" variant="info" type="submit"><CheckLg size={15} />&nbsp;ثبت پاسخ</Button>
                                            <Button className="group-Btn" variant="danger" onClick={cancelTicket}><DashCircle size={15} />&nbsp;انصراف</Button>
                                        </div>
                                    </Fragment>
                                </form>
                            }
                            {currTicket.TicketStatus === "Closed" &&
                                <div>
                                    <Button className="group-Btn mt-2" variant="danger" onClick={cancelTicket}><X size={20} />&nbsp;بستن</Button>
                                </div>
                            }
                        </Row>

                    }
                    {!currTicket &&
                        <form readOnly onSubmit={handleSubmit(search)}>
                            <Row className="rowBorder" id="divFilters">
                                <div className="rowTitle">
                                    فیلترهای جستجو
                                    &nbsp;
                                    {showFilters && <EyeSlashFill size={20} className="hoverIcon" style={{ cursor: "pointer", color: "#ca237e" }} onClick={() => showHideFilter(true)} />}
                                    {!showFilters && <EyeFill size={20} className="hoverIcon" style={{ cursor: "pointer", color: "#ca237e" }} onClick={() => showHideFilter(false)} />}
                                </div>
                                <FormGroup className="col-md-2">
                                    <label>وضعیت تیکت: </label>
                                    <BihamtaMultiSelect dataSource={selectStatusOptions} valueItem="value" displayItem="text" onItemCheckChanged={onStatusChecked} />
                                </FormGroup>

                                <FormGroup className="col-md-2">
                                    <label>از تاریخ: </label>
                                    <DatePicker ref={inputDateFrom} popperPlacement="top-start" isGregorian={false} timePicker={false} className="form-control"
                                        onChange={value => dateFilters.current.TicketDateFrom = value.local("en").format("YYYY-MM-DD")} />
                                </FormGroup>
                                <FormGroup className="col-md-2">
                                    <label>تا تاریخ: </label>
                                    <DatePicker ref={inputDateTo} popperPlacement="top-start" isGregorian={false} timePicker={false} className="form-control"
                                        onChange={value => dateFilters.current.TicketDateTo = value.local("en").format("YYYY-MM-DD")} />
                                </FormGroup>
                                <FormGroup className="col-md-2">
                                    <label>شناسه پیگیری: </label>
                                    <Form.Control name="ID" ref={register({})} />
                                </FormGroup>
                                <FormGroup className="col-md-2">
                                    <label>مشخصات مشتری: </label>
                                    <Form.Control name="CustomerName" ref={register({})} />
                                </FormGroup>
                                <FormGroup className="col-md-2">
                                    <label>موضوع تیکت: </label>
                                    <Form.Control name="TicketSubject" ref={register({})} />
                                </FormGroup>
                            </Row>
                            <div className="mt-2">
                                <Button variant="secondary" className="group-Btn-large" type="submit"><Search size={16} />&nbsp; جستجوی تیکت</Button>
                            </div>
                        </form>

                    }
                    <BihamtaTable columns={tableColes} rowButtons={tableRowButtons} filterData={filterData.current} pageSizeList={[10, 20, 30, 50, 100]} defaultPageSize={30} maxHeight={350}
                        searchMethod={(data) => dispatch(getCustomerTicketList(data))} reducerName="customerDataReducer" objectName="customerTicketList" hasPaging={true} rowClick={showTicket} />
                </Card.Body>
            </Card>
        </div>
    )
}
export default Ticket;